export const CATEGORY_ACTIONS = 'actions';
export const CATEGORY_PAGES = 'pages';
export const CATEGORY_BUSINESS_PARTNERS = 'businessPartners';
export const CATEGORY_AFFILIATES = 'affiliates';
export const CATEGORY_NETWORKS = 'networks';
export const CATEGORY_APPLICATIONS = 'applications';
export const CATEGORY_CUSTOMER_COMPANIES = 'customerCompanies';
